import fastCompany from 'assets/images/homepage/logos/fast-company-logo.webp'
import fastCompanyMob from 'assets/images/homepage/logos/fast-company-logo-mobile.webp'
import forbes from 'assets/images/homepage/logos/forbes-logo.webp'
import fortune from 'assets/images/homepage/logos/fortune-logo.webp'
import marieClaire from 'assets/images/homepage/logos/marie-claire-logo.webp'
import marieClaireMob from 'assets/images/homepage/logos/marie-claire-logo-mobile.webp'
import wired from 'assets/images/homepage/logos/wired-logo.webp'

export const pressRowLogos = [
  {
    name: 'Fast Company',
    imgDesktop: fastCompany,
    imgMobile: fastCompanyMob,
    link: 'https://www.fastcompany.com/90749911/we-already-have-too-many-workspaces-we-need-to-build-non-work-spaces',
  },
  {
    name: 'Forbes',
    imgDesktop: forbes,
    link: 'https://www.forbes.com/sites/rachelkramerbussel/2021/05/12/levar-burton-book-club-selections-include-james-baldwin-octavia-butler-and-jesmyn-ward-titles/?sh=144b2a9849a0',
  },
  {
    name: 'Fortune',
    imgDesktop: fortune,
    link: 'https://fortune.com/2020/10/25/doomscrolling-social-media-2020-election-twitter-facebook-instagram/',
  },
  {
    name: 'Marie Claire',
    imgDesktop: marieClaire,
    imgMobile: marieClaireMob,
    link: 'https://www.marieclaire.com/career-advice/a37068926/online-book-clubs-business/',
  },
  {
    name: 'Wired',
    imgDesktop: wired,
    link: 'https://www.wired.com/story/how-to-find-or-start-online-book-club/',
  },
]
